// extracted by mini-css-extract-plugin
module.exports = {"root":"_2dC5E","shadow":"Y9wS5","leftTop":"_1VfN5","rightTop":"_29q8A","centerTop":"_3X-U4","bg":"_3fdEY"};